
import { Vue, Component, Watch } from "vue-property-decorator"
import api from "../honcierge-api"
import EditDialog from "@/components/RecommendCollections/EditDialog.vue"
import TableItemIsEnabled from "@/components/_share/TableItemIsEnabled.vue"
import { AxiosError } from "axios"
import { ArticleSearchMaster, RecommendCollection } from "types/index"
import { DataTableHeader } from "vuetify/types"

@Component({ components: { EditDialog, TableItemIsEnabled } })
export default class RecommendCollections extends Vue {
  get headers(): DataTableHeader[] {
    return [
      { text: "優先度", value: "priority" },
      { text: "タイトル", value: "title" },
      { text: "トップページに表示", value: "showOnTop" },
      { text: "有効/無効", value: "isEnabled" },
      { text: "操作", value: "action", sortable: false },
    ]
  }

  private loading = true
  private dialog = false
  private recommendCollections: RecommendCollection["view"][] = []
  private isEnabledFilters: Array<{
    name: string
    isEnabled: boolean | undefined
  }> = [
    { name: "絞り込みなし", isEnabled: undefined },
    { name: "有効", isEnabled: true },
    { name: "無効", isEnabled: false },
  ]
  private showOnTopFilters: Array<{
    name: string
    showOnTop: boolean | undefined
  }> = [
    { name: "絞り込みなし", showOnTop: undefined },
    { name: "トップページに表示", showOnTop: true },
    { name: "トップページに表示しない", showOnTop: false },
  ]
  private selectedFilter: {
    name: string
    isEnabled: boolean | undefined
    showOnTop: boolean | undefined
  } = { name: "絞り込みなし", isEnabled: undefined, showOnTop: undefined }
  private articleSearchMaster: ArticleSearchMaster["searchMaster"] = {
    statuses: [],
    editors: [],
    writers: [],
    categories: [],
    appAffiliates: [],
  }

  private totalPages = 0
  private pagination = {
    sortBy: ["priority"],
    sortDesc: [true],
    itemsPerPage: -1,
    page: 1,
  }

  public created(): void {
    this.loading = false
    this.getRecommendCollections()
    this.getArticleSearchMaster()
  }

  private getArticleSearchMaster() {
    api
      .adminSearchMasters()
      .then((res) => {
        const result = res.data.searchMaster
        this.articleSearchMaster.statuses = result.articleStatuses
        this.articleSearchMaster.editors = result.editors
        this.articleSearchMaster.writers = result.writers
        this.articleSearchMaster.categories = result.categories
        this.articleSearchMaster.appAffiliates = result.appAffiliates
      })
      .catch((e: AxiosError) => {
        console.log(e.stack)
      })
  }

  @Watch("pagination.page", { deep: true, immediate: true })
  private onChangePage() {
    this.loading = true
    setTimeout(() => {
      this.getRecommendCollections()
      this.loading = false
    }, 500)
  }

  private getRecommendCollections(_page?: number) {
    const showOnTop = this.selectedFilter.showOnTop
    const isEnabled = this.selectedFilter.isEnabled
    const page = _page ? _page : this.pagination.page
    const per = 10
    const sortBy = this.pagination.sortBy[0]
    const descending = this.pagination.sortDesc[0]
    const excludedIds: number[] = []
    const includes = [
      "id",
      "priority",
      "title",
      "show_on_top",
      "is_enabled",
      "created_at",
      "updated_at",
    ]

    api
      .getRecommendCollections({
        showOnTop,
        isEnabled,
        page,
        per,
        sortBy,
        descending,
        excludedIds,
        includes,
      })
      .then((res) => {
        this.totalPages = res.data.meta.totalPages
        this.recommendCollections = res.data.recommendCollections
      })
      .catch(() => {
        this.$toasted.error("おすすめ一覧の取得に失敗しました")
      })
  }

  private search() {
    this.resetPagination()
    this.getRecommendCollections()
  }

  private resetPagination() {
    this.pagination.page = 1
  }

  private createRecommendCollection() {
    if (this.pagination.page > 1) {
      this.pagination.page = 1 // Watchされていることに注意
    } else {
      this.getRecommendCollections()
    }
    this.$toasted.success("おすすめを新規作成しました")
  }

  private updateRecommendCollection(page: number) {
    this.getRecommendCollections(page)
    this.$toasted.success("おすすめを更新しました")
  }

  private deleteRecommendCollection(page: number) {
    this.getRecommendCollections(page)
    this.$toasted.success("おすすめを削除しました")
  }

  private async open(id?: number) {
    if (id) {
      const refs = this.$refs[id] as InstanceType<typeof EditDialog>
      if (Array.isArray(refs)) {
        refs[0].open()
      } else {
        refs.open()
      }
    } else {
      const newDialog = this.$refs.newDialog as InstanceType<typeof EditDialog>
      newDialog.open()
    }
  }
}
